<template>
  <div
    v-if="show"
    class="popup-wrap"
    @click.self="close"
  >
    <div class="popup-wrap__inner">
      <div
        :class="[ size ? 'popup_' + size : '' ]"
        class="popup"
      >
        <div class="popup__in">
          <button
            class="popup__close"
            type="button"
            @click.prevent="close"
          />
          <div class="popup__content">
            <div class="island">
              <div class="island__head">
                {{ title }}
              </div>
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        default: '',
      },
      show: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      show(val) {
        if (val) {
          document.addEventListener('keydown', this.closeOnEsc);
          document.body.classList.add('is-popup-opened');
        } else {
          document.removeEventListener('keydown', this.closeOnEsc);
          document.body.classList.remove('is-popup-opened');
        }
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
      closeOnEsc(e) {
        if (this.show && e.keyCode === 27) {
          this.close();
        }
      },
    },
  };
</script>
